/** Micro course category display order, per Jenn's confirmed category list. */
export const CATEGORY_ORDER = [
  'Building and Enhancing Skills',
  'Add to Your Coping Skills',
  'Boundary Setting',
  'Organizing Yourself',
  'Actually Doing Self-Care',
  'Invest in Yourself',
];

/**
 * Group micro courses by category for the library view. A course can belong
 * to more than one category (its categories[] array), so it may appear in
 * more than one group — matches "some courses fit in multiple categories."
 * Courses are sorted alphabetically by title within each group. Any
 * category not in CATEGORY_ORDER is appended at the end, alphabetically.
 */
export const groupByCategory = (courses) => {
  const groups = new Map();
  const ensureGroup = (name) => {
    if (!groups.has(name)) groups.set(name, []);
    return groups.get(name);
  };

  for (const course of courses) {
    const categories = course.categories?.length ? course.categories : ['Uncategorized'];
    for (const category of categories) {
      ensureGroup(category).push(course);
    }
  }

  for (const list of groups.values()) {
    list.sort((a, b) => a.title.localeCompare(b.title));
  }

  const orderedNames = [
    ...CATEGORY_ORDER.filter(name => groups.has(name)),
    ...[...groups.keys()].filter(name => !CATEGORY_ORDER.includes(name)).sort(),
  ];

  return orderedNames.map(name => ({ name, courses: groups.get(name) }));
};
